import { z } from "zod";

/** The tabs of a document's trace: the admission decision first, then how it was resolved and parsed. */
export const DOCUMENT_TRACE_TABS = [
  { value: "admission", label: "Admission" },
  { value: "connectors", label: "Connector resolution" },
  { value: "sections", label: "Section title classification" },
] as const;

/** What a document's trace page is told by its URL: which tab to open. */
export const documentTraceFiltersSchema = z.object({
  tab: z.enum(["admission", "connectors", "sections"]).default("admission"),
});
